import { FormField, Input } from '@wix/design-system'
import { useMetadata } from '@wix/funnel-builder-lizard'
import React, { FC, useEffect } from 'react'

import { ALL_COUNTRY_CODES, DEFAULT_COUNTRY_CODE } from './consts'
import { Dropdown } from './dropdown'
import s from './index.scss'
import { CountryCode } from './types'

export const PhoneNumberControl: FC<{
  defaultValue?: [CountryCode, string]
  onChange: (value: [CountryCode, string]) => void
  statusMessage?: string
  name?: string
}> = ({ name, statusMessage, defaultValue = [], onChange }) => {
  const [metadata] = useMetadata()
  const initialCountryCode =
    defaultValue[0] || ALL_COUNTRY_CODES.find(c => c.shortKey === metadata.geo) || DEFAULT_COUNTRY_CODE
  const [countryCode, setCountryCode] = React.useState<CountryCode>(initialCountryCode)
  const [phoneNumber, setPhoneNumber] = React.useState<string>(defaultValue[1] || '')

  useEffect(() => {
    onChange([countryCode, phoneNumber])

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countryCode, phoneNumber])

  const onCountryCodeChange = (countryCode: CountryCode) => {
    setCountryCode(countryCode)
  }

  const onPhoneNumberChange = (number: string) => {
    setPhoneNumber(number)
  }

  return (
    <div className={s.PhoneNumberControl}>
      <Dropdown value={countryCode} onChange={onCountryCodeChange} />
      <FormField status={(statusMessage && 'error') || undefined} statusMessage={statusMessage}>
        <Input
          name={name || 'phone'}
          autocomplete="tel-national"
          placeholder="(201) 555-0123"
          value={phoneNumber}
          onChange={e => onPhoneNumberChange(e.target.value)}
          onClear={() => onPhoneNumberChange('')}
          clearButton
          type="tel"
        />
      </FormField>
    </div>
  )
}
